import api from "Common/Client/Interceptor";

export const businessGroupService = {
  getPendingList: async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await api.get(`BusinessGroup/Admin/PendingList`, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "*/*",
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error in getPendingList:", error);
      throw error; // Caller will handle it
    }
  },

  approveBusinessGroup: async (businessGroupId, isApprove) => {
    const token = localStorage.getItem("token");
    try {
      const response = await api.post(
        `BusinessGroup/Approve-BusinessGroup`,
        {
          businessGroupId,
          isApprove,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error in approveBusinessGroup:", error);
      throw error; // Caller will handle it
    }
  },
};
